import React, { useEffect, useRef, useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { TabPanel, TabView } from 'primereact/tabview';
import { MultiSelect } from 'primereact/multiselect';
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Api } from '../../../services/api';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Editor } from 'primereact/editor';

const MyPerformanceReview = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isReminderBoxOpen, setIsReminderBoxOpen] = useState(false);
    const toast = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    // const [formList, setFormList] = useState(true);
    const [formList, setFormList] = useState([]);
    const [archiveFormList, setArchiveFormList] = useState(true);

    const [activeIndex, setActiveIndex] = useState(0);

    const [selectedProduct, setSelectedProduct] = useState(null);


    //! ----------------
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [conversationId, setConversationId] = useState(null);
    const [conversationType, setConversationType] = useState(null);


    const [reason, setReason] = useState('');
    const [quarterForReminder, setQuarterForReminder] = useState('');
    const [yearForReminder, setYearForReminder] = useState('');
    const [reminderReason, setReminderReason] = useState('');

    const [projectDeletetitle, setProjectDeleteTitle] = useState('Are you sure you want to Archive this project?');
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] =
        useState(false);


    const [roleId, setRoleId] = useState(null);
    const [teamMemberList, setTeamMemberList] = useState([]);
    const [selectedTeamMember, setSelectedTeamMember] = useState(null);
    const [reminderBoxError, setReminderBoxError] = useState('');
    const reminderFormRef = useRef(null);
    const requestFormRef = useRef(null);

    //! ----------------

     //* ----------------
    /** search Filtter function Start */

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        team_member_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        supervisor_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        quater: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
        year: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
    });
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const [selectedYear, setSelectedYear] = useState(null);
    const [yearOptions, setYearOptions] = useState([]);

    const onYearChange = (e) => {
        setSelectedYear(e.value);
        let _filters = { ...filters };
        _filters['year'].constraints[0].value = e.value;
        setFilters(_filters);
    };

    const initFilters = () => {
        const currentYear = new Date().getFullYear();
        const prevYear = (currentYear - 1).toString();
        
        // Generate last 5 years options
        const years = [];
        for (let i = 0; i <= 5; i++) {
            years.push({ label: (currentYear - i).toString(), value: (currentYear - i).toString() });
        }
        setYearOptions(years);
        // If selectedYear is not set, default to prevYear
        const defaultYear = selectedYear || prevYear;
        if (!selectedYear) setSelectedYear(defaultYear);

        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            team_member_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            supervisor_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            quater: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            year: { operator: FilterOperator.AND, constraints: [{ value: defaultYear, matchMode: FilterMatchMode.EQUALS }] },
        });
        setGlobalFilterValue('');
    };

    /** search Filtter function End */
    //! ----------------



    const openEditModal = (event) => {
        // navigate('/form/' + event.id)
        localStorage.setItem('quarterlyHuddleConRedirect', JSON.stringify({
            rows: rows,
            first: first,
            sortField: sortField,
            sortOrder: sortOrder,

        }))

        localStorage.setItem('quarterlyHuddleConSelectedProduct', JSON.stringify(event))


        // navigate('/form/' + event.slug)

        navigate('/performance-review-form/' + event.slug)
    };



    const reminderBox = (rowData) => {
        setReminderBoxError('');
        setQuarterForReminder('');
        setYearForReminder(new Date().getFullYear() - 1);
        setReminderReason('');
        setSelectedTeamMember(null);
        setIsReminderBoxOpen(true);
    };

    useEffect(() => {
        // Fetch form data here...
        if (location.state?.selectedId) {
            // Automatically select the row with the passed identifier
            const selectedId = location.state.selectedId;
            const selectedForm = formList.find(form => form.id === selectedId);
            setSelectedProduct(selectedForm);
        }
    }, [location.state, formList]);

    useEffect(() => {
        console.log('Fetching projects...');
        getFormData();
        const storedRoleId = localStorage.getItem('role_id');
        setRoleId(storedRoleId);
        console.log('role_id', storedRoleId);
        initFilters();
    }, []);



    const getFormData = async () => {

        var user_id = localStorage.getItem('user_id');
        // var roll_id = localStorage.getItem('roll_id');

        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };


        var _body = {
            user_id: user_id,

        }

        fetch(Api.API_BASE_URL + 'performance-review/get-all', {
            method: 'POST',
            body: JSON.stringify(_body),
            headers: headers,

        })
            .then((response) => response.json())
            .then((response) => {
                setIsLoading(false);
                console.log(response)
                if (response.error != '') {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.error, life: 3000 });
                } else {
                    // setFormList(response.result)
                    // setArchiveFormList(response.archive)
                    // setTeamMemberList(response.teamMember)
                    // console.log('ksksksks', response.teamMember)
                    // *-------Suraj Code for Shorting-----------
                    const sortedFormList = response.result.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                    const sortedArchiveFormList = response.archive.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                    setFormList(sortedFormList);
                    setArchiveFormList(sortedArchiveFormList);
                    setTeamMemberList(response.teamMember);

                    console.log('setFilters---------->', setFilters)
                    // !-------Suraj Code for Shorting-----------

                    //* --------------------------
                    let playbookRedirect = localStorage.getItem('quarterlyHuddleConRedirect');
                    if (playbookRedirect) {
                        playbookRedirect = JSON.parse(playbookRedirect)
                        setFirst(playbookRedirect.first || 0)
                        setRows(playbookRedirect.rows || 12)
                        setSortField(playbookRedirect.sortField || 'quater')
                        setSortOrder(playbookRedirect.sortOrder || -1)

                    }
                    let playbookSelectedProduct = localStorage.getItem('quarterlyHuddleConSelectedProduct');


                    if (playbookSelectedProduct) {
                        playbookSelectedProduct = JSON.parse(playbookSelectedProduct)
                        setSelectedRowData(playbookSelectedProduct)
                    }

                    localStorage.removeItem('quarterlyHuddleConSelectedProduct')
                    localStorage.removeItem('quarterlyHuddleConRedirect');
                    //! --------------------------
                }
            })
            // .then((response) => console.log('ksksksks', response))
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        console.log({
            supervisor_name: selectedRowData.supervisor_name,
            status: 'Request',
            reason: reason
        });


        var userId = localStorage.getItem('user_id');

        fetch(Api.API_BASE_URL + 'performance-review/request', {
            method: 'POST',

            body: JSON.stringify({

                userId: userId,
                conversationId: conversationId,
                conversationType: conversationType,
                reason: reason,
            }),
        })
            .then(response => response.json())
            .then(data => {
                // Handle the response data
                console.log('Success:', data);
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Form submitted successfully', life: 3000 });
                setIsModalOpen(false);
            })
            .catch((error) => {
                console.error('Error:', error);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Form submission failed', life: 3000 });
            });
    };

    const handleReminderSubmit = (e) => {
        e.preventDefault();


        var user_id = localStorage.getItem('user_id');

        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };
        fetch(Api.API_BASE_URL + 'performance-review/notify-for-all', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({

                user_id: user_id,
                year: yearForReminder,
                // quarter: quarterForReminder,
                //quarter: 'Q1',
                team_member: selectedTeamMember,
                // conversationId: conversationId,
                // conversationType: conversationType,
                reason: reminderReason,
            }),
        })
            .then(response => response.json())
            .then(data => {
                // Handle the response data
                console.log('Success:', data);
                if (data.error != '') {
                    setReminderBoxError(data.error);
                    // toast.current.show({ severity: 'error', summary: 'Error', detail: data.error, life: 3000});
                } else {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Form submitted successfully', life: 3000 });
                    setIsReminderBoxOpen(false);
                    getFormData();
                    setReminderBoxError('');
                }

                // ----------Reload -----------
            })
            .catch((error) => {
                console.error('Error:', error);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Form submission failed', life: 3000 });
            });
    };

    // ---------------------------------------------------------------------------------
  
    

    const header = (
        <div className="flex flex-wrap align-items-center justify-content-end m-2">
            <Dropdown 
                value={selectedYear} 
                options={yearOptions} 
                onChange={onYearChange} 
                placeholder="Select a Year" 
                className="mr-2"
                style={{ width: '150px' }}
            />
        </div>
    );

    const dateBodyTemplate = (rowData, field) => {
        if (!rowData[field]) return "";
        // Split by 'T' or space to strip time and timezone, preventing client-side shifts
        return String(rowData[field]).split('T')[0].split(' ')[0];
    };

    const onRowSelect = (e) => {
        const rowData = e.data;
        openEditModal(rowData);
        setSelectedRowData(rowData);
    };

   
    const confirmDelete = async () => {
        var user_id = localStorage.getItem('user_id');

        var _body = {
            user_id: user_id,
            // userId: userId,
            conversationId: conversationId,
        }

        fetch(Api.API_BASE_URL + 'performance-review/status-update', {
            method: 'POST',
            body: JSON.stringify(_body),

        })
            .then((response) => response.json())
            .then((response) => {
                setIsLoading(false);
                console.log(response)
                if (response.error != '') {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.error, life: 3000 });
                } else {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Form deleted successfully', life: 3000 });
                    getFormData();
                    setIsDeleteConfirmationModalOpen(false);
                }
            })
    }




    const renderSelectForQuarter = () => {

        return <select
            required
            name='quarter'
            id='quarter'
            // className={'select-text-color-' + val}
            value={quarterForReminder}
            onChange={(e) => {
                setQuarterForReminder(e.target.value);
            }}
            style={{ width: '100%', textAlign: 'center', height: "40px", fontSize: '16px', color: 'Black', backgroundColor: '#EEEEEE', border: 'none' }}
        >
            <option selected disabled value=""></option>
            <option value="Q1">Quarter-1</option>
            <option value="Q2">Quarter-2</option>
            <option value="Q3">Quarter-3</option>
            <option value="Q4">Quarter-4</option>
        </select>
    };
    const renderYearSelect = () => {

        const currentYear = new Date().getFullYear();
        // Explain: Previous two years and current year
        const years = [];
        for (let i = 2; i >= 0; i--) {
            const year = currentYear - i;
            years.push({ label: year.toString(), value: year });
        }

        return (
            <Dropdown
                value={yearForReminder}
                options={years}
                onChange={(e) => setYearForReminder(e.value)}
                placeholder="Select Year"
                className="w-full"
                style={{ height: '44px', display: 'flex', alignItems: 'center' }}
                required
            />
        );
    };

    const renderTeamMemberSelect = () => {

        return (
            <MultiSelect 
                value={selectedTeamMember} 
                onChange={(e) => setSelectedTeamMember(e.value)} 
                options={teamMemberList} 
                optionLabel={(e) => e.first_name + ' ' + e.last_name} 
                optionValue="id"
                placeholder="Select Team Member" 
                display="chip"
                className="w-full"
                style={{ minHeight: '44px', display: 'flex', alignItems: 'center' }}
                required
            />
        );
    };

      //! ---------------

    const closeModal = () => {
        setIsModalOpen(false);
        setIsDeleteConfirmationModalOpen(false);
        // setIsResendEmailModalOpen(false);
    };

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(8);
    const [sortField, setSortField] = useState('quater');
    const [sortOrder, setSortOrder] = useState(-1);
    const fetchData = async (event) => {
        const { first, rows, sortField, sortOrder } = event;
        setFirst(first);
        setRows(rows);
        setSortField(sortField);
        setSortOrder(sortOrder);
    }
    
    const reminderDialogFooter = (
        <div className="flex justify-content-end gap-2 pt-3 pb-4 pr-4">
            <Button label="Cancel" icon="pi pi-times" onClick={() => setIsReminderBoxOpen(false)} className="p-button-text p-button-secondary" />
            <Button label="Send Review" icon="pi pi-send" onClick={() => reminderFormRef.current.requestSubmit()} className="customSave-button" />
        </div>
    );

    const requestDialogFooter = (
        <div className="flex justify-content-end gap-2 pt-3 border-top-1 border-200">
            <Button label="Cancel" icon="pi pi-times" onClick={() => setIsModalOpen(false)} className="p-button-text" />
            <Button label="Submit Request" icon="pi pi-check" onClick={() => requestFormRef.current.requestSubmit()} className="customSave-button" />
        </div>
    );
    //* ---------------


    return (
        <div className="surface-ground px-4 py-5 md:px-6 lg:px-8">
            <Toast ref={toast} />
            <ConfirmDialog />
            
            {/* Header Section */}
            <div className="flex flex-column md:flex-row justify-content-between align-items-center mb-5">
                <div>
                    <h2 className="text-3xl font-bold text-900 m-0">My Performance Reviews</h2>
                    <span className="text-500 text-lg block mt-1">Manage and review performance evaluations.</span>
                </div>
                <div className="mt-3 md:mt-0">
                    <Button 
                        label="Send Performance Review" 
                        icon="pi pi-send" 
                        className="customSave-button p-button-raised" 
                        onClick={reminderBox} 
                    />
                </div>
            </div>

            <div className="card shadow-2 border-round bg-white p-4">
                <div>
                    {isLoading ? (
                        <div className="flex justify-content-center align-items-center" style={{ height: '300px' }}>
                            <div className="spinner"></div>
                            <span className="ml-2">Loading...</span>
                        </div>
                    ) : (
                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                            <TabPanel header="Active" className="p-2 pb-2" >
                                <DataTable
                                    size="small"
                                    value={formList}
                                    paginator

                                    rows={rows}
                                    first={first}
                                    sortField={sortField}
                                    sortOrder={sortOrder}
                                    onPage={fetchData}
                                    onSort={fetchData}

                                    tableStyle={{ minWidth: '50rem' }}
                                    selectionMode="single"
                                    onRowSelect={onRowSelect}
                                    onRowUnselect={onRowSelect}

                                    selection={selectedRowData}
                                    // onSelectionChange={(e) => setSelectedProduct(e.value)}
                                    header={header}

                                    filters={filters}
                                    filterDisplay="menu"
                                    globalFilterFields={['team_member_name', 'supervisor_name', 'date', 'quater', 'year']}

                                    emptyMessage="No records found"
                                >
                                    <Column field="team_member_name" sortable header="User" ></Column>
                                    <Column field="role_name" sortable header="Role" className="col-padding" ></Column>
                                    <Column field="supervisor_name" sortable header="Supervisor Name" ></Column>
                                    <Column field="date" sortable header="Date" body={(rowData) => dateBodyTemplate(rowData, 'date')}></Column>
                                    <Column field="year" sortable header="Year"></Column>
                                    <Column field="created_at" header="Created At" className="col-padding"></Column>
                                    <Column field="created_by" header="Created By" className="col-padding"></Column>
                                    <Column field="modify_at" header="Modified At" className="col-padding"></Column>
                                    <Column field="modify_by" header="Modified By" className="col-padding"></Column>
                                </DataTable>
                            </TabPanel>


                            <TabPanel header="Archive" className="p-2 pb-2" >
                                <DataTable
                                    size="small"
                                    value={archiveFormList}
                                    paginator

                                    rows={rows}
                                    first={first}
                                    sortField={sortField}
                                    sortOrder={sortOrder}
                                    onPage={fetchData}
                                    onSort={fetchData}

                                    tableStyle={{ minWidth: '50rem' }}
                                    selectionMode="single"
                                    onRowSelect={onRowSelect}
                                    onRowUnselect={onRowSelect}

                                    selection={selectedRowData}

                                    header={header}

                                    filters={filters}
                                    filterDisplay="menu"
                                    globalFilterFields={['team_member_name', 'supervisor_name', 'date', 'quater', 'year']}

                                    emptyMessage="No records found"
                                >
                                    <Column field="team_member_name" sortable header="User" className="col-padding" ></Column>
                                    <Column field="role_name" sortable header="Role" className="col-padding" ></Column>
                                    <Column field="supervisor_name" sortable header="Supervisor Name" className="col-padding" ></Column>
                                    <Column field="date" sortable header="Date" className="col-padding" body={(rowData) => dateBodyTemplate(rowData, 'date')}></Column>
                                    <Column field="year" sortable header="Year" className="col-padding"></Column>
                                    <Column field="created_at" header="Created At" className="col-padding"></Column>
                                    <Column field="created_by" header="Created By" className="col-padding"></Column>
                                    <Column field="modify_at" header="Modified At" className="col-padding"></Column>
                                    <Column field="modify_by" header="Modified By" className="col-padding"></Column>
                                </DataTable>
                            </TabPanel>
                        </TabView>
                    )}
                </div>
            </div>

            {/* // --------------------------------Edit Modal Dialog------------------------------------------------------ */}
            <Dialog 
                header="Request Review Interaction" 
                visible={isModalOpen} 
                style={{ width: '450px' }} 
                modal 
                className="p-fluid" 
                contentClassName="p-4"
                footer={requestDialogFooter}
                onHide={() => setIsModalOpen(false)}
            >
                {selectedRowData && (
                    <div className="flex flex-column">
                        <form onSubmit={handleSubmit} ref={requestFormRef}>
                            <div className="field mb-4">
                                <label className="font-bold block mb-2">Supervisor Name</label>
                                <div className="p-3 surface-100 border-round">
                                    {selectedRowData.supervisor_name}
                                </div>
                            </div>

                            <div className="field mb-4">
                                <label htmlFor="reason" className="font-bold block mb-2">Reason for Request</label>
                                <InputTextarea
                                    id="reason"
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                    className="w-full"
                                    rows={4}
                                    maxLength={500}
                                    placeholder="Enter your reason here..."
                                />
                            </div>
                        </form>
                    </div>
                )}
            </Dialog>

            {/* // --------------------------------Send Review Dialog (Reminder)------------------------------- */}
            <Dialog 
                header={
                    <div className="flex align-items-center gap-2">
                        <div className="surface-100 border-circle p-2 flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                            <i className="pi pi-send text-blue-600 text-xl"></i>
                        </div>
                        <span className="text-xl font-bold text-900">Send Performance Review</span>
                    </div>
                }
                visible={isReminderBoxOpen} 
                style={{ width: '600px', maxWidth: '90vw' }} 
                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                modal 
                footer={reminderDialogFooter}
                onHide={() => setIsReminderBoxOpen(false)}
            >
                <div className="flex flex-column p-4">
                    <div className="surface-50 border-round p-3 mb-4 flex align-items-start">
                        <i className="pi pi-info-circle text-blue-500 mr-2 mt-1 text-lg"></i>
                        <span className="text-600 line-height-3 text-sm">
                            Initiate a new performance review cycle. Selected team members will receive a notification to begin their self-evaluation.
                        </span>
                    </div>

                     {reminderBoxError && (
                        <div className="bg-red-50 border-round p-3 mb-4 flex align-items-start border-1 border-red-200">
                            <i className="pi pi-exclamation-circle text-red-500 mr-2 mt-1"></i>
                            <span className="text-red-700 font-medium text-sm">{reminderBoxError}</span>
                        </div>
                    )}
                    
                    <form onSubmit={handleReminderSubmit} ref={reminderFormRef}>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-8 mb-4">
                                <label htmlFor="teamMember" className="font-semibold text-900 mb-2 block text-sm">
                                    Team Members <span className="text-red-500">*</span>
                                </label>
                                {renderTeamMemberSelect()}
                            </div>

                            <div className="field col-12 md:col-4 mb-4">
                                <label htmlFor="year" className="font-semibold text-900 mb-2 block text-sm">
                                    Review Year <span className="text-red-500">*</span>
                                </label>
                                {renderYearSelect()}
                            </div>
                        </div>

                        <div className="field">
                            <label htmlFor="reminderReason" className="font-semibold text-900 mb-2 block text-sm">
                                Message / Instructions
                            </label>
                            <Editor
                                id="reminderReason"
                                value={reminderReason}
                                onTextChange={(e) => setReminderReason(e.htmlValue)}
                                style={{ height: '120px' }}
                                placeholder="Dear Team, please complete your annual performance self-evaluation for the selected review year."
                            />
                        </div>
                    </form>
                </div>
            </Dialog>

            {/* // --------------------------------DELETE Confirmation------------------------------------ */}
            <Dialog 
                header="Confirm Action" 
                visible={isDeleteConfirmationModalOpen} 
                style={{ width: '350px' }} 
                modal 
                footer={
                    <div>
                        <Button label="No" icon="pi pi-times" onClick={closeModal} className="p-button-text" />
                        <Button label="Yes" icon="pi pi-check" onClick={confirmDelete} className="p-button-danger" autoFocus />
                    </div>
                } 
                onHide={closeModal}
            >
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem', color: '#f59e0b' }} />
                    <span>{projectDeletetitle}</span>
                </div>
            </Dialog>
        </div>
    )

}

export default MyPerformanceReview